import ListingHeader from "app/pages/Listing/ListingHeader/ListingHeader";

export default props => <ListingHeader {...props} />;
